import { useUpc } from '@nuxt-common/media-card-large/app/composables/useUpc';
import { toValue } from '@vueuse/core';
import { useProduct } from '~/modules/product/composables/useProduct';
import useColor from '~/modules/color/composables/useColor';
import useSize from '~/modules/size/composables/useSize';
import { swapKV } from '~/utils/objects/swapKV';

/**
 * @param {import('@vueuse/core').MaybeRef<string | number>} upcId
 */
export const useUpcPreselectConsolidated = (upcId) => {
  const productId = useProduct();
  const { upcData } = useUpc(productId);
  const { selectedSizeId } = useSize();
  const { selectedColorId } = useColor();
  const swapped = swapKV(upcData.value.upcMap);

  const preselectedUpc = toValue(upcId);

  const traitsKey = swapped[preselectedUpc];
  if (!traitsKey) {
    return;
  }
  const [colorId, sizeId] = traitsKey.toString().split('_');
  if (sizeId !== undefined) {
    selectedSizeId.value = +sizeId;
  }
  // Removed undefined check here because we always get something for colorId from traitsKey if its not falsy
  selectedColorId.value = +colorId;

  // TODO Implement orientation preselection
};
